import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, Card, Tooltip, Icon, Switch } from "antd";
import {
  getOutlets,
  syncOutlets,
  updateOutlet,
} from "../../../../../../actions/fnbAction";
import * as Func from "../../../../../../helpers/functions";
import {
  PageListComponent,
  ListComponent,
  HeaderListComponent,
  FilterDropdown,
} from "../../../../common/component/Index";
import Wrapper from "containers/backend/common/component/Wrapper";
import Ripple from "containers/backend/common/component/Ripple";
import EllipsisText from "containers/backend/common/component/EllipsisText";
import Outlet from "../../../../../../models/Outlet";

const ListCols = [
  "propertyName",
  "name",
  "code",
  "status",
];
const ModelFields = Object.getOwnPropertyNames(new Outlet());
const pageSize = 10;

class OutletList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titleItemTable: Func.getTitleTable(ListCols, [], []),
      modelItem: ModelFields,
      filters: {
        PageIndex: 1,
        PageSize: pageSize,
      },
      componentTable: {
        propertyName: {
          width: 240,
          key: "propertyName",
          align: "left",
          render: (text) => (
            <EllipsisText
              title={text}
              content={text}
              contentMaxWidth={300}
              overlayClassName={"max-width-500"}
              overlayComponent={Tooltip}
            />
          ),
        },
        name: {
          width: 220,
          key: "name",
          sorter: true,
          align: "left",
          render: (text, record) => (
            <EllipsisText
              title={text || record?.outletName}
              content={text || record?.outletName}
              contentMaxWidth={300}
              overlayClassName={"max-width-500"}
              overlayComponent={Tooltip}
            />
          ),
        },
        code: {
          width: 100,
          key: "code",
          align: "left",
          render: (text, record) => (
            <EllipsisText
              title={text}
              content={text}
              contentMaxWidth={300}
              overlayClassName={"max-width-500"}
              overlayComponent={Tooltip}
            />
          ),
        },
        status: {
          width: 180,
          key: "status",
          render: (status, record) => {
            const isActive = Number(status) === 1;
            const isUpdating = (this.props.outletUpdatingIds || []).includes(
              record?.id,
            );
            return (
              <div
                style={{ display: "flex", alignItems: "center", gap: 8 }}
              >
                <Switch
                  checked={isActive}
                  loading={isUpdating}
                  disabled={isUpdating}
                  onChange={(checked) =>
                    this.handleToggleStatus(record, checked)
                  }
                />
                <span>
                  {isActive
                    ? this.props.t("item.fnb.outlet.active")
                    : this.props.t("item.fnb.outlet.inactive")}
                </span>
              </div>
            );
          },
        },
      },
    };
  }

  componentDidMount() {
    this.props.actions.getOutlets(this.state.filters);
  }

  handleSync = () => {
    this.props.actions.syncOutlets({ filters: this.state.filters });
  };

  handleToggleStatus = (record, checked) => {
    this.props.actions.updateOutlet({
      outletId: record.id,
      filters: this.state.filters,
      updatePayload: {
        ...record,
        status: checked ? 1 : 0,
      },
    });
  };

  buildFilters = (pagination, filters, sorter) => {
    const currentFilters = this.state.filters || {};
    const hasPropertyNameKey = Object.prototype.hasOwnProperty.call(
      filters || {},
      "propertyName",
    );
    const hasNameKey = Object.prototype.hasOwnProperty.call(
      filters || {},
      "name",
    );
    const propertyNameFilterRaw = filters?.propertyName;
    const nameFilterRaw = filters?.name;
    const propertyNameFilter = Array.isArray(propertyNameFilterRaw)
      ? propertyNameFilterRaw[0]
      : undefined;
    const nameFilter = Array.isArray(nameFilterRaw)
      ? nameFilterRaw[0]
      : undefined;
    const propertyNameEmpty =
      typeof propertyNameFilter === "string" &&
      propertyNameFilter.trim() === "";
    const nameEmpty =
      typeof nameFilter === "string" && nameFilter.trim() === "";
    const propertyNameCleared =
      (hasPropertyNameKey &&
        Array.isArray(propertyNameFilterRaw) &&
        propertyNameFilterRaw.length === 0) ||
      propertyNameEmpty;
    const nameCleared =
      (hasNameKey &&
        Array.isArray(nameFilterRaw) &&
        nameFilterRaw.length === 0) ||
      nameEmpty;
    const propertyNameValue = propertyNameCleared
      ? undefined
      : propertyNameFilter === undefined || propertyNameEmpty
        ? currentFilters.PropertyName
        : propertyNameFilter;
    const searchTerm = nameCleared
      ? undefined
      : nameFilter === undefined || nameEmpty
        ? currentFilters.SearchTerm
        : nameFilter;
    const orderBy = sorter?.order ? sorter.field : undefined;
    const orderByDesc = sorter?.order ? sorter.order === "descend" : undefined;
    const pageIndex = pagination?.current || currentFilters.PageIndex || 1;
    const pageSizeValue =
      pagination?.pageSize || currentFilters.PageSize || pageSize;
    const changedFilters =
      propertyNameValue !== currentFilters.PropertyName ||
      searchTerm !== currentFilters.SearchTerm ||
      orderBy !== currentFilters.OrderBy ||
      orderByDesc !== currentFilters.OrderByDesc;

    return Func.removeObjectNull({
      ...currentFilters,
      PageIndex: changedFilters ? 1 : pageIndex,
      PageSize: pageSizeValue,
      PropertyName: propertyNameValue,
      SearchTerm: searchTerm,
      OrderBy: orderBy,
      OrderByDesc: orderByDesc,
    });
  };

  handleChange = (pagination, filters, sorter) => {
    const nextFilters = this.buildFilters(pagination, filters, sorter);
    this.setState({ filters: nextFilters });
    this.props.actions.getOutlets(nextFilters);
  };

  render() {
    const { t, outlets, loading, syncing, pagination } = this.props;
    const { titleItemTable, modelItem, componentTable, filters } = this.state;
    const columns = Func.columnsTable({
      titleTable: titleItemTable,
      component: {
        ...componentTable,
        propertyName: {
          ...componentTable.propertyName,
          filteredValue: filters.PropertyName ? [filters.PropertyName] : null,
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <FilterDropdown
              setSelectedKeys={setSelectedKeys}
              selectedKeys={selectedKeys}
              confirm={confirm}
              clearFilters={clearFilters}
            />
          ),
          filterIcon: (filtered) => (
            <Icon
              type="search"
              style={{ color: filtered ? "#1890ff" : undefined }}
            />
          ),
        },
        name: {
          ...componentTable.name,
          filteredValue: filters.SearchTerm ? [filters.SearchTerm] : null,
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <FilterDropdown
              setSelectedKeys={setSelectedKeys}
              selectedKeys={selectedKeys}
              confirm={confirm}
              clearFilters={clearFilters}
            />
          ),
          filterIcon: (filtered) => (
            <Icon
              type="search"
              style={{ color: filtered ? "#1890ff" : undefined }}
            />
          ),
        },
      },
      itemName: "fnb.outlet",
    });

    return (
      <Fragment>
        <PageListComponent>
          <HeaderListComponent
            path={this.props.match.path}
            groupPath={"fnb"}
            group={"outlet"}
            titleHeader={t("navigation.outlets", { defaultValue: "Outlets" })}
            componentRight={
              <Fragment>
                <Wrapper style={{ display: "flex" }}>
                  <Wrapper>
                    <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                      <Button
                        icon="sync"
                        loading={syncing}
                        onClick={this.handleSync}
                        className="btn btn-primary"
                      >
                        {t(`action.sync`)}
                      </Button>
                    </Ripple>
                  </Wrapper>
                </Wrapper>
              </Fragment>
            }
          />
            <ListComponent
              tableKey="fnb-outlet-list"
              rowKey={(record, k) => (record.id ? record.id : k)}
              loading={{ spinning: loading, size: "large" }}
              dataSource={Func.getDataSource(outlets || [], modelItem)}
              columns={columns}
              onChange={this.handleChange}
              pagination={{
                total: pagination?.totalCount || 0,
                totalPage: pagination?.totalPage || 0,
                defaultCurrent: pagination?.defaultCurrent || 0,
                defaultPageSize: pagination?.pageSize || 0,
              }}
              componentTableList={{}}
              classChildren="p-0"
              classParent="m-0"
            />
        </PageListComponent>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  outlets: state.fnbReducer.outlets,
  loading: state.fnbReducer.outletsLoading,
  syncing: state.fnbReducer.syncing,
  outletUpdatingIds: state.fnbReducer.outletUpdatingIds,
  pagination: state.fnbReducer.outletsPagination,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getOutlets,
      syncOutlets,
      updateOutlet,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(OutletList);
